import { FC, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import NotificationDispatch, {
  showErrorNotification,
  showSuccessNotification,
} from "../../context/notificationContext";
import { useI18n } from "../../hooks/useTranslations";
import { useSubsidiariesApi } from "../../http/subsidiaries/api";
import { UpsertSubsidiary } from "../../http/subsidiaries/types";
import Header from "../ui/Header";
import Panel from "../ui/Panel";
import SubsidiaryForm, { SubsidiaryFormBody } from "./SubsidiaryForm";

const NewSubsidiary: FC = () => {
  const i18n = useI18n();
  const dispatch = useContext(NotificationDispatch);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const subsidiariesApi = useSubsidiariesApi();
  const navigate = useNavigate();

  const onSubmit = async (formData: SubsidiaryFormBody) => {
    const body: UpsertSubsidiary = {
      name: formData.name,
      allowMultiPlates: formData.allowMultiPlates,
      vatDeductionCode: formData.vatDeductionCode,
      vatServiceCode: formData.vatServiceCode,
      countryIsoCodeAlpha2: formData.countryIsoCodeAlpha2,
      defaultLanguage: formData.defaultLanguage?.value,
      semiramisOrganizationCode: formData.semiramisOrganizationCode,
    };

    setIsSubmitting(true);
    try {
      const response = await subsidiariesApi.insertAdminSubsidiary(body);
      dispatch(showSuccessNotification(i18n.t));
      navigate(`/admin/subsidiaries/${response.id}`);
    } catch (err) {
      dispatch(showErrorNotification(i18n, err));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Header title={i18n.t.subsidiaries.new} />
      <Panel>
        <SubsidiaryForm isDisabled={isSubmitting} onSubmit={onSubmit} />
      </Panel>
    </>
  );
};

export default NewSubsidiary;
